var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHidden28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69289 5.30711L23.0929 20.7071L23.1071 20.6929L23.7071 21.2929L22.2929 22.7071L19.2529 19.6671C17.692 20.5171 15.9024 21 14 21C9.33603 21 5.35002 18.0974 3.74988 14C4.62303 11.7642 6.20659 9.88412 8.22306 8.63727L6.29289 6.70711L7.69289 5.30711ZM15.9041 16.3184L17.7635 18.1778C16.6181 18.7057 15.3431 19 14 19C10.469 19 7.40895 16.966 5.93496 14C6.75663 12.3466 8.07117 10.9829 9.68539 10.0996L11.6816 12.0959C11.2557 12.6138 11 13.2771 11 14C11 15.6569 12.3431 17 14 17C14.7229 17 15.3862 16.7443 15.9041 16.3184Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3388 7.12461L14.2168 9.00256C17.6559 9.08388 20.6213 11.0949 22.065 14C21.7568 14.6202 21.3792 15.1997 20.9425 15.7283L22.3617 17.1475C23.1559 16.2193 23.7982 15.1573 24.2501 14C22.65 9.90265 18.664 7 14 7C13.4353 7 12.8806 7.04255 12.3388 7.12461Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHidden28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;